<template>
    <div class="main-content clearfix">
        <div class="container">
            <div class="card p-4">
                <div class="how-section">
                    <div class="how-steps">
                        <div class="row align-items-center">
                            <div class="col-md-6 col-lg-6 order-1 order-md-0">
                                <div class="how-img">
                                    <img src="assets/images/work-01.jpg" alt="how it work">
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="how-content">
                                    <h3>Choose a Floor Plan</h3>
                                    <p>Wevisu offers you many options for floor plans making it accessible for you to
                                        choose the most realistic floor plan that resembles your current space you are
                                        looking to remodel. Our experts have created over 50+ floor plans for you to
                                        play with, without needing any background knowledge of architecture or design.
                                        We made it easy for all users</p>
                                    <button type="button" class="btn btn-primary">Click Here to Start Your FREE 3D
                                        Design!</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="how-steps">
                        <div class="row align-items-center">
                            <div class="col-md-6 col-lg-6">
                                <div class="how-content">
                                    <h3>Choose a Template</h3>
                                    <p>Our team has created over 100 models of different styles for you to choose from,
                                        making it a quick and easy way to filter your 3D design. Replacing and combining
                                        certain materials to an already pre- selected style can help bring inspiration
                                        and ideas to you in order to help achieve your home decor goals.</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6">
                                <div class="how-img">
                                    <img src="assets/images/work-02.jpg" alt="how it work">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="how-steps">
                        <div class="row align-items-center">
                            <div class="col-md-6 col-lg-6 order-1 order-md-0">
                                <div class="how-img">
                                    <img src="assets/images/work-03.jpg" alt="how it work">
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6">
                                <div class="how-content">
                                    <h3>Virtual Showroom</h3>
                                    <p>Start designing with over 25,000 of today's trending materials from brands we all
                                        love in 1 3D visualizer tool. The technology behind our 3D tool gives you the
                                        option to change ALL materials shown in ANY template. You are able to change the
                                        fridge, floors, backsplash, tubs, toilets, you name it! You can see how your
                                        backsplash will look with your countertops. You now know how the mirror will
                                        look above the vanity. See what cabinets work best with your floor...</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="how-steps">
                        <div class="row align-items-center">
                            <div class="col-md-6 col-lg-6">
                                <div class="how-content">
                                    <h3>Finalize Your Materials</h3>
                                    <p>Add your selected items to your cart and purchase! Shipping included and
                                        delivered in under 3 weeks guaranteed! Say goodbye to arranging order pick ups,
                                        because we deliver your materials straight to your door! With our outstanding
                                        customer service, our team will coordinate and assure a safe and on time
                                        delivery of your materials.</p>
                                    <button type="button" class="btn btn-primary">Click Here to Start Your FREE 3D
                                        Design!</button>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6">
                                <div class="how-img">
                                    <img src="assets/images/work-04.jpg" alt="how it work">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions}  from 'vuex'
export default {
    name: 'howitworks',

    methods:{
        ...mapActions('Common',['updateNewLayout'])
    },
    mounted() {
     this.updateNewLayout('Yes');
    },
}

</script>
